import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

// INTERFACES/INTERFACES  -------------------------------------------------
import { User } from '@asambleas-models/user.model';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { JSON_HEADER, environment } from '@asambleas-env/environment';
import { HttpClient } from '@angular/common/http';

/**
 * El proposito de este servicio es proveer de la información del usuario
 * por ahora solo usuario regular
 * Además contiene las funciones y rutinas que están relacionadas con los usuarios
 *
 * @export
 * @class UserService
 */
@Injectable()
export class UserService {

    user: User;

    private userSource = new BehaviorSubject<User>(this.user);
    currentUser = this.userSource.asObservable();

    users: Observable<any[]>;

    constructor(
        public http: HttpClient
    ) {
        console.log('User Service Constructor');
    }

    /**
     * Para crear obeto de usuario al iniciar sesion
     * @param u Datos de usuario en objeto
     */
    createUser(u: any) {
        let user: User = new User(u)
        this.userSource.next(user)
    }

    /**
     * Actualiza los datos del observable de Usuario
     *
     * @param {User} u
     * @memberof UserService
     */
    changeUser(u: User) {
        console.log('<change>', u)
        let changed = this.user
        Object.assign(changed, u)
        this.userSource.next(changed)
    }

    async loadUser() {
        if (this.user) {
            return this.user;
        } else {
            this.user = new User();
            return this.user;
        }
    }

    getUser() {
        let user = JSON.parse(localStorage.getItem('user'));

        return user;
    }

    setUserLocalStorage(user) {
        localStorage.setItem('user', JSON.stringify(user));
    }

    /**
     * Regresa una lista de todos los usuarios
     *
     * @returns
     * @memberof UserService
     */
    getUsers() {
        const headers = JSON_HEADER;

        return this.http.get(environment.apiEndPoint + '/users', {
            headers
        })
    }

    // userToCsv() {
    //     const options = {
    //         fieldSeparator: ',',
    //         quoteStrings: '"',
    //         decimalseparator: '.',
    //         showLabels: true,
    //         showTitle: true,
    //         useBom: true,
    //         noDownload: false,
    //         headers: [
    //             'Email',
    //             'Estado Civil',
    //             'Fecha Nacimiento',
    //             'Lugar Nacimiento',
    //             'Primer Apellido',
    //             'Primer Nombre',
    //             'Segundo Apellido',
    //             'Segundo Nombre',
    //             'Tipo Documento']
    //     };
    //     const filename = 'lista de usuarios';
    //     this.getUsers()
    //         .subscribe(users => {
    //             console.log(users);
    //             // return users;
    //             new Angular5Csv(users, filename, options);
    //         });
    // }

}



// WEBPACK FOOTER //
// ./src/app/services/user/user.service.ts